import {
    type UpdateCompanyForAdminResponseType,
    type UpdateCompanyForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const UpdateCompanyForAdmin = async (params: UpdateCompanyForAdminRequestType): Promise<UpdateCompanyForAdminResponseType> => {
    return await request<UpdateCompanyForAdminResponseType>("/company/updateCompanyForAdmin", {
        body: JSON.stringify(params),
        method: "PUT"
    });
};

export default UpdateCompanyForAdmin;
